var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.6146,
    y: 20.6134,
    width: 23.4852,
    height: 23.4852,
    rx: 1.1,
    fill: "white",
    stroke: "#293035",
    strokeWidth: 1.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18744 27.4197C2.85014 23.4077 2.73192 17.204 5.91086 12.9886C8.43895 9.6362 13.3015 7.02676 18.4611 8.5079L17.1772 5.26983C16.8922 4.57553 17.2275 3.78772 17.9093 3.49723C18.5912 3.20679 19.3713 3.53534 19.651 4.24191L22.0331 10.2218C22.179 10.578 22.1579 10.9752 22.0038 11.3081C21.8669 11.6039 21.6155 11.8601 21.2892 11.9897L15.8217 15.3481C15.1398 15.6384 14.3658 15.2968 14.0805 14.6026C13.6704 13.6045 14.7838 12.8483 14.8117 12.8295L17.9141 10.8827C13.5153 10.1766 9.83342 12.2487 8.02611 14.6512C5.59084 17.8672 5.68148 22.5963 8.21821 25.6518C8.69813 26.2135 8.63433 27.0876 8.07053 27.5705C7.51889 28.0589 6.66163 27.9935 6.18744 27.4197Z",
    fill: "#604099"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/rotate-right.858bbd77d8802ee06688ab3703028109.svg";
export { ForwardRef as ReactComponent };